/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetDaikinAuthStatusPathParameters } from 'api/actions/get-daikin-auth-status/get-daikin-auth-status-path-parameters';
import { GetDaikinAuthStatusResponse } from 'api/actions/get-daikin-auth-status/get-daikin-auth-status-response';

type GetDaikinAuthStatusQueryParameters = Record<string, any>;

/**
 * The path of the GetDaikinAuthStatus action.
 */
export const getDaikinAuthStatusActionPath = new SweetPath<keyof GetDaikinAuthStatusPathParameters>(
  '/daikin/auth/status',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetDaikinAuthStatus actions.
 */
export default function createGetDaikinAuthStatusAction(axios: AxiosInstance) {
  return function getDaikinAuthStatusAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetDaikinAuthStatusQueryParameters } = {}) {
    const path = getDaikinAuthStatusActionPath.original;

    return axios.get<GetDaikinAuthStatusResponse, GetDaikinAuthStatusResponse>(path, { params: query, headers });
  };
}
